//@constants
const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');

const apiURLBuilder = require('core/apiURLBuilder');
const { getCommercialCardsList } = require('utilities/commercialAdsHelper');

const commercialAdsAction = require('actions/commercialInterstitialsAds');
//@utilities
const {  APIGet, APIPost } = require('utilities/APIRequestHelper');

const getCardsRequest = () => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_GET_CARDS_REQUEST
})

const getCardsSuccess = (cards) => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_GET_CARDS_SUCCESS,
    payload: { cards }
})

const getCardsFailure = (error) => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_GET_CARDS_FAILURE,
    payload: { error }
})

const setVisibleStep = step => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_SET_VISIBLE_STEP,
    payload: { step }
});

const validateStep = step => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_VALIDATE_STEP,
    payload: { step }
});

const setWillCancel = willCancel => ({
    type: actionTypes.ACCOUNT_PAYMENT_PURCHASE_DEFERRAL_WILL_CANCEL,
    payload: { willCancel }
});

const clearRequest = () => ({ type: actionTypes.CARD_PAYMENT_PURCHASE_DEFERRAL_CLEAR });

const confirmDeferralRequest = () => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_REQUEST
});

const confirmDeferralSuccess = () => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_SUCCESS
});

const confirmDeferralFailure = error => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_CONFIRMATION_FAILURE,
    payload: { error }
});

const getQuotaRequest = () => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_QUOTA_REQUEST

});

const getQuotaSuccess = (data) => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_QUOTA_SUCCESS,
    payload: { data }
});

const getQuotaFailure = error => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_QUOTA_FAILURE,
    payload: { error }
});

const setDeferralOption = option => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_OPTION,
    payload: { option }
});

const getSpecificQuotaRequest = () => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_SPECIFIC_QUOTA_REQUEST
});

const setSpecificQuotaAmount = amount => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_SPECIFIC_QUOTA_AMOUNT,
    payload: { amount }
});

const selectCard = cardId => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_SELECT_CARD,
    payload: { cardId }
});

const clearConfirmDeferral = () => ({
    type: actionTypes.ACCOUNT_CARD_PAYMENT_PURCHASE_DEFERRAL_CLEAR
});

const requestQuotaData = (immCard, immMovement, immAccount, quota) => ({
    importe: immMovement.getIn(['balance', 'amount']),
    divisa: immMovement.getIn(['balance', 'currency']),
    productoCuenta: immAccount.get('product'),
    numeroContratoCuenta: immAccount.get('contractNumber'),
    fecAnotacion: immMovement.get('valueDate'),
    fecOperacion: immMovement.get('date'),
    codigoterminaldgo: immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], '').trim
        ? immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], '').trim()
        : immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], ''),
    numerodgo: immMovement.getIn(['operacionDGO', 'numerodgo']),
    numMovDia: immMovement.getIn(['extra', 'movementNumber']),
    nummovDgo: immMovement.get('nummov'),
    panTarjeta: immCard.get('number'),
    centroMovDgo: immMovement.getIn(['operacionDGO', 'centro', 'centro']),
    empresaMovDgo: immMovement.getIn(['operacionDGO', 'centro', 'empresa']),
    numPlazosSeleccionados: quota
})


const getQuotaData = (immCard, immMovement, immAccount, quota) => (dispatch) => {
    const params = requestQuotaData(immCard, immMovement, immAccount, quota)
    dispatch(getQuotaRequest())
    return APIGet(dispatch, apiURLBuilder.getURL('accountFinanceAmortizationTable'), {query: params}).then(
        (q) => {
            const parseAmountObject = (obj) => ({
                amount: obj.importe,
                currency: obj.divisa
            })
            const installmentList  = (q.registro || []).map(
                (elem) => ({
                    nextAmortizationDate: elem.fechaAmortizacion,
                    interests: {amount: elem.intereses, currency: elem.moneda},
                    amortizedCapital: parseAmountObject(elem.capitalAmortizado),
                    installmentTotal: parseAmountObject(elem.totalRecibo),
                    pendingCapital: parseAmountObject(elem.capitalPendiente)
                }))
            const response = {
                currentQuota: quota,
                interests: parseAmountObject(q.totalIntereses),
                quotaMonthly:  parseAmountObject(q.cuotaMensual),
                totalAmount: parseAmountObject(q.importeTotal),
                numPlazosSeleccionados: quota,
                installmentList
            }
            dispatch(getQuotaSuccess(response))
        }).catch(({error}) => dispatch(getQuotaFailure(error)))
}

const getQuotaAmount = (immCard, immMovement, immAccount, quota) => (dispatch) => {
    const params = requestQuotaData(immCard, immMovement, immAccount, quota);
    dispatch(getSpecificQuotaRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('accountFinanceAmortizationTable'), {query: params}).then(
        (q) => {
            const parseAmountObject = (obj) => ({
                amount: obj.importe,
                currency: obj.divisa
            })
            dispatch(setSpecificQuotaAmount(parseAmountObject(q.cuotaMensual)))
        }).catch(({error}) => dispatch(getQuotaFailure(error)))
}

const getCards = (contractNumber, product, amount, currency) => (dispatch, getState) => {
    dispatch(getCardsRequest());
    const data = {
        query: {
            numeroContrato: contractNumber,
            producto: product,
            importe: amount,
            divisa: currency
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('accountFinanceCards'), data).then(
        response => {
            const commercialCardsList = getCommercialCardsList(getState().cards, getState().flagBasedFeatures, getState().profile);
            const promise = dispatch(commercialAdsAction.requestAds(commercialCardsList))
            if (promise) {
                promise.then(
                    () => {
                        dispatch(getCardsSuccess(response))
                    }
                )
            } else {
                dispatch(getCardsSuccess(response))
            }
    }).catch(({error}) => dispatch(getCardsFailure(error)));
};


const confirmDeferral = (accountId, cardId, movementId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const state  = getState()
        const immCard = state.cards.getIn(['byId', cardId]);
        const immMovement = state.accountsTransactions.getIn([accountId, 'byId', movementId]);
        const immAccount = state.accounts.getIn(['byId', accountId]);
        const immStep = state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'financingData']);
        const goCode = immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], '').trim
            ? immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], '').trim()
            : immMovement.getIn(['operacionDGO', 'codigoterminaldgo'], '');

        const params = {
            query: {
                dataToken,
                "cuentaPersonal": {
                    "cuentaPartenon": {
                      "numerodecontrato": immAccount.get('contractNumber'),
                      "producto": immAccount.get('product')
                    }
                },
                "fecAnotacion": immMovement.get('valueDate'),
                "fecOperacion": immMovement.get('date'),
                "importeMov": {
                    "divisa": immMovement.getIn(['balance', 'currency']),
                    "importe": immMovement.getIn(['balance', 'amount'])
                },
                "numPlazosSeleccionados": immStep.get('numPlazosSeleccionados'),
                "movDGO": {
                    "centro": {
                        "centro": immMovement.getIn(['operacionDGO', 'centro', 'centro']),
                        "empresa": immMovement.getIn(['operacionDGO', 'centro', 'empresa'])
                    },
                    "codigoterminaldgo": goCode,
                    "numerodgo": immMovement.getIn(['operacionDGO', 'numerodgo'])
                },
                "numMovDia": immMovement.getIn(['extra', 'movementNumber']),
                "nummovDGO": immMovement.get('nummov'),
                "panTarjeta": immCard.get('number')
            }
        };

        dispatch(confirmDeferralRequest());

        return APIPost({
            dispatch,
            params,
            endpoint: 'accountPaymentPurchaseDeferral'
        })
            .then(() => dispatch(confirmDeferralSuccess()))
            .catch(({error}) => dispatch(confirmDeferralFailure(error)));
    };

    return Promise.resolve().then(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};



module.exports = {
    getQuotaAmount,
    getQuotaData,
    clearRequest,
    confirmDeferral,
    setDeferralOption,
    setVisibleStep,
    setWillCancel,
    validateStep,
    getCards,
    selectCard,
    clearConfirmDeferral
};
